import { useEffect, useState } from 'react';
import { Button, Modal } from './kit';
import { contractsApi, type ContractDetail } from '../api/contracts';

/** Bir sözleşmeyi (yasal metni) modal içinde gösterir. body HTML'dir (admin tarafından yönetilir). */
export function ContractModal({ contractKey, onClose }: { contractKey: string | null; onClose: () => void }) {
  const [data, setData] = useState<ContractDetail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!contractKey) return;
    setData(null);
    setError(null);
    contractsApi.get(contractKey).then(setData).catch(() => setError('Sözleşme yüklenemedi'));
  }, [contractKey]);

  return (
    <Modal
      open={contractKey !== null}
      onClose={onClose}
      eyebrow="Sözleşme"
      title={data?.title ?? 'Sözleşme'}
      size="lg"
      footer={<Button onClick={onClose}>Kapat</Button>}
    >
      {error && <div className="auth-error">{error}</div>}
      {!data && !error && <div className="placeholder-note">Yükleniyor…</div>}
      {data && (
        <div className="contract-body" dangerouslySetInnerHTML={{ __html: data.body ?? '' }} />
      )}
    </Modal>
  );
}
